import api from '@/api/index.js'

const fare_group_operators = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_FARE_GROUP_OPERATORS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_FARE_GROUP_OPERATORS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_FARE_GROUP_OPERATORS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadFareGroupOperators({commit}, fareGroupID) {
      commit('SET_FARE_GROUP_OPERATORS_LOADING', true);
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_OPERATORS_ERROR', null)
      commit('SET_FARE_GROUP_OPERATORS', [])
      return api.get(`fare-groups/${fareGroupID}/operators`)
        .then((response) => {
          commit('SET_FARE_GROUP_OPERATORS', response)
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_OPERATORS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default fare_group_operators
